import { Link, Typography } from '@material-ui/core';
import { Column, Columns, Stack } from '@superdispatch/ui';
import { DescriptionItem, TextBox } from '@superdispatch/ui-lab';
import { useEffect, useState } from 'react';
import { formatCurrency, formatPlural } from 'shared/helpers/IntlHelpers';
import { ShieldCarIcon } from 'shared/icons';
import { trackLoadboardEvent } from '../../core/LoadboardAnalytics';
import { CargoInsuranceMinimumDetails } from '../../core/shipper-requirements/CargoInsuranceMinimumDetails';
import { CargoInsuranceMinimumDTO } from '../../core/shipper-requirements/data/CargoInsuranceMinimumDTO';

interface PostingDetailsInsuranceRequirementsProps {
  limits: CargoInsuranceMinimumDTO[];
}

export function PostingDetailsInsuranceRequirements({
  limits,
}: PostingDetailsInsuranceRequirementsProps) {
  const [isExpanded, setIsExpandedS] = useState(false);

  useEffect(() => {
    if (isExpanded) {
      trackLoadboardEvent({ name: 'Carrier Viewed Cargo Minimum Details' });
    }
  }, [isExpanded]);

  return (
    <Stack aria-label="Cargo Insurance details">
      <Columns align="center" space="xxsmall">
        <Column width="fluid">
          <DescriptionItem
            icon={
              <TextBox color="purple">
                <ShieldCarIcon fontSize="small" color="inherit" />
              </TextBox>
            }
          >
            <Typography variant="body1">Cargo Insurance Minimum</Typography>
          </DescriptionItem>
        </Column>
        <Column width="content">
          {limits.length > 1 && (
            <Link
              href="#"
              color="primary"
              variant="body2"
              onClick={() => {
                setIsExpandedS((prev) => !prev);
              }}
            >
              {isExpanded ? 'Hide Details' : 'Show Details'}
            </Link>
          )}
        </Column>
      </Columns>
      <DescriptionItem inset={true}>
        {!isExpanded ? (
          <CargoInsuranceMinimumDetails limits={limits} />
        ) : (
          <Stack aria-label="Cargo insurance minimum details" space="xxsmall">
            {limits.map((limit, index) => (
              <Typography key={limit.trailer_size}>
                {formatCurrency(limit.cargo_limit || 0, {
                  minimumFractionDigits: 0,
                })}
                <TextBox color="secondary">
                  {' '}
                  {formatPlural(
                    limit.trailer_size,
                    `for ${limit.trailer_size} unit trailer`,
                    `for ${limit.trailer_size}${index + 1 === limits.length ? '+' : ''} units`,
                  )}
                </TextBox>
              </Typography>
            ))}
          </Stack>
        )}
      </DescriptionItem>
    </Stack>
  );
}
